import {DashboardForloebModel} from "./dashboardUddannelseslaeger/DashboardForloebModel";
import React, {createContext, ReactNode, useCallback, useContext, useReducer} from "react";
import {DashboardVejledersamtaleModel} from "./dashboardVejledersamtaler/DashboardVejledersamtaleModel";
import {DashboardBrugerKompetenceProgressModel} from "./dashboardKompetencer/DashboardBrugerKompetenceProgressModel";
import {DashboardBrugerKompetenceAktivitetModel} from "./dashboardKompetencer/DashboardBrugerKompetenceAktivitetModel";
import {DashboardKompetenceKlarmeldtModel} from "./dashboardKompetencer/DashboardKompetenceKlarmeldtModel";
import {DashboardVejledningModel} from "./dashboardOpmaerksomhedspunkter/DashboardVejledningModel";
import {
    DashboardForloebManglerGodkendelseModel
} from "./dashboardOpmaerksomhedspunkter/DashboardForloebManglerGodkendelseModel";
import {DashboardUddannelsesplanModel} from "./dashboardUddannelsesplaner/DashboardUddannelsesplanModel";
import {DashboardListForloebModel} from "./dashboardList/models/DashboardListForloebModel";
import {DashboardListUkoModel} from "./dashboardList/models/DashboardListForloebUkoModel";

type DashboardContextType = {
    dashboardListData: DashboardListForloebModel[];
    dashboardListUkoData: DashboardListUkoModel[];
    dashboardListDataIsLoading: boolean;
    uddannelseslaeger: DashboardForloebModel[];
    uddannelseslaegerIsLoading: boolean;
    vejledersamtaler: DashboardVejledersamtaleModel[];
    vejledersamtalerIsLoading: boolean;
    uddannelsesplaner: DashboardUddannelsesplanModel[];
    uddannelsesplanerIsLoading: boolean;
    kompetenceProgress: DashboardBrugerKompetenceProgressModel[];
    kompetenceProgressIsLoading: boolean;
    kompetenceAktivitet: DashboardBrugerKompetenceAktivitetModel[];
    kompetenceAktivitetIsLoading: boolean;
    kompetenceKlarmeldinger: DashboardKompetenceKlarmeldtModel[];
    kompetenceKlarmeldingerIsLoading: boolean;
    vejledning: DashboardVejledningModel[];
    vejledningIsLoading: boolean;
    gamleForloebUdenGodkendelse: DashboardForloebManglerGodkendelseModel[];
    gamleForloebUdenGodkendelseIsLoading: boolean;
}

enum DashboardReducerActionType {
    SetDashboardListData,
    SetDashboardListUkoData,
    SetDashboardListDataIsLoading,
    SetUddannelseslaeger,
    SetUddannelseslaegerIsLoading,
    SetVejledersamtaler,
    SetVejledersamtalerIsLoading,
    SetUddannelsesplaner,
    SetUddannelsesplanerIsLoading,
    SetKompetenceProgress,
    SetKompetenceProgressIsLoading,
    SetKompetenceAktivitet,
    SetKompetenceAktivitetIsLoading,
    SetKompetenceKlarmeldinger,
    SetKompetenceKlarmeldingerIsLoading,
    SetVejledning,
    SetVejledningIsLoading,
    SetGamleForloebUdenGodkendelse,
    SetGamleForloebUdenGodkendelseIsLoading,
}

const dashboarReducer = (
    state: DashboardContextType,
    action: { type: DashboardReducerActionType, payload: Partial<DashboardContextType> }
): DashboardContextType => {
    switch (action.type) {
        case DashboardReducerActionType.SetDashboardListData:
            return {
                ...state,
                dashboardListData: action.payload.dashboardListData ?? state.dashboardListData
            }
        case DashboardReducerActionType.SetDashboardListUkoData:
            return {
                ...state,
                dashboardListUkoData: action.payload.dashboardListUkoData ?? state.dashboardListUkoData
            }
        case DashboardReducerActionType.SetDashboardListDataIsLoading:
            return {
                ...state,
                dashboardListDataIsLoading: action.payload.dashboardListDataIsLoading ?? state.dashboardListDataIsLoading
            }
        case DashboardReducerActionType.SetUddannelseslaeger:
            return {
                ...state,
                uddannelseslaeger: action.payload.uddannelseslaeger ?? state.uddannelseslaeger
            }
        case DashboardReducerActionType.SetUddannelseslaegerIsLoading:
            return {
                ...state,
                uddannelseslaegerIsLoading: action.payload.uddannelseslaegerIsLoading ?? state.uddannelseslaegerIsLoading
            }
        case DashboardReducerActionType.SetVejledersamtaler:
            return {
                ...state,
                vejledersamtaler: action.payload.vejledersamtaler ?? state.vejledersamtaler
            }
        case DashboardReducerActionType.SetVejledersamtalerIsLoading:
            return {
                ...state,
                vejledersamtalerIsLoading: action.payload.vejledersamtalerIsLoading ?? state.vejledersamtalerIsLoading
            }
        case DashboardReducerActionType.SetUddannelsesplaner:
            return {
                ...state,
                uddannelsesplaner: action.payload.uddannelsesplaner ?? state.uddannelsesplaner
            }
        case DashboardReducerActionType.SetUddannelsesplanerIsLoading:
            return {
                ...state,
                uddannelsesplanerIsLoading: action.payload.uddannelsesplanerIsLoading ?? state.uddannelsesplanerIsLoading
            }
        case DashboardReducerActionType.SetKompetenceProgress:
            return {
                ...state,
                kompetenceProgress: action.payload.kompetenceProgress ?? state.kompetenceProgress
            }
        case DashboardReducerActionType.SetKompetenceProgressIsLoading:
            return {
                ...state,
                kompetenceProgressIsLoading: action.payload.kompetenceProgressIsLoading ?? state.kompetenceProgressIsLoading
            }
        case DashboardReducerActionType.SetKompetenceAktivitet:
            return {
                ...state,
                kompetenceAktivitet: action.payload.kompetenceAktivitet ?? state.kompetenceAktivitet
            }
        case DashboardReducerActionType.SetKompetenceAktivitetIsLoading:
            return {
                ...state,
                kompetenceAktivitetIsLoading: action.payload.kompetenceAktivitetIsLoading ?? state.kompetenceAktivitetIsLoading
            }
        case DashboardReducerActionType.SetKompetenceKlarmeldinger:
            return {
                ...state,
                kompetenceKlarmeldinger: action.payload.kompetenceKlarmeldinger ?? state.kompetenceKlarmeldinger
            }
        case DashboardReducerActionType.SetKompetenceKlarmeldingerIsLoading:
            return {
                ...state,
                kompetenceKlarmeldingerIsLoading: action.payload.kompetenceKlarmeldingerIsLoading ?? state.kompetenceKlarmeldingerIsLoading
            }
        case DashboardReducerActionType.SetVejledning:
            return {
                ...state,
                vejledning: action.payload.vejledning ?? state.vejledning
            }
        case DashboardReducerActionType.SetVejledningIsLoading:
            return {
                ...state,
                vejledningIsLoading: action.payload.vejledningIsLoading ?? state.vejledningIsLoading
            }
        case DashboardReducerActionType.SetGamleForloebUdenGodkendelse:
            return {
                ...state,
                gamleForloebUdenGodkendelse: action.payload.gamleForloebUdenGodkendelse ?? state.gamleForloebUdenGodkendelse
            }
        case DashboardReducerActionType.SetGamleForloebUdenGodkendelseIsLoading:
            return {
                ...state,
                gamleForloebUdenGodkendelseIsLoading: action.payload.gamleForloebUdenGodkendelseIsLoading ?? state.gamleForloebUdenGodkendelseIsLoading
            }
    }
}

const DashboardContext = createContext<{
    state: DashboardContextType,
    setDashboardListData: (payload: DashboardListForloebModel[]) => void,
    setDashboardListUkoData: (payload: DashboardListUkoModel[]) => void,
    setDashboardListDataIsLoading: (isLoading: boolean) => void;
    setUddannelseslaeger: (payload: DashboardForloebModel[]) => void,
    setUddannelseslaegerIsLoading: (isLoading: boolean) => void;
    setVejledersamtaler: (payload: DashboardVejledersamtaleModel[]) => void,
    setVejledersamtalerIsLoading: (isLoading: boolean) => void;
    setUddannelsesplaner: (payload: DashboardUddannelsesplanModel[]) => void,
    setUddannelsesplanerIsLoading: (isLoading: boolean) => void;
    setKompetenceProgress: (payload: DashboardBrugerKompetenceProgressModel[]) => void,
    setKompetenceProgressIsLoading: (isLoading: boolean) => void;
    setKompetenceAktivitet: (payload: DashboardBrugerKompetenceAktivitetModel[]) => void,
    setKompetenceAktivitetIsLoading: (isLoading: boolean) => void;
    setKompetenceKlarmeldinger: (payload: DashboardKompetenceKlarmeldtModel[]) => void,
    setKompetenceKlarmeldingerIsLoading: (isLoading: boolean) => void;
    setVejledning: (payload: DashboardVejledningModel[]) => void,
    setVejledningIsLoading: (isLoading: boolean) => void;
    setGamleForloebUdenGodkendelse: (payload: DashboardForloebManglerGodkendelseModel[]) => void,
    setGamleForloebUdenGodkendelseIsLoading: (isLoading: boolean) => void;
} | undefined>(undefined);

export const useDashboardContext = () => {
    const context = useContext(DashboardContext);
    if (!context) throw new Error("useDashboardContext must be used in DashboardContextProvider");
    return context;
};

type DashboardContextProviderProps = { children?: ReactNode; }

const DashboardContextProvider = ({children}: DashboardContextProviderProps) => {

    const [state, dispatch] = useReducer(dashboarReducer, {
        dashboardListData: [],
        dashboardListUkoData: [],
        dashboardListDataIsLoading: true,
        uddannelseslaeger: [],
        uddannelseslaegerIsLoading: true,
        vejledersamtaler: [],
        vejledersamtalerIsLoading: true,
        uddannelsesplaner: [],
        uddannelsesplanerIsLoading: true,
        kompetenceProgress: [],
        kompetenceProgressIsLoading: true,
        kompetenceAktivitet: [],
        kompetenceAktivitetIsLoading: true,
        kompetenceKlarmeldinger: [],
        kompetenceKlarmeldingerIsLoading: true,
        vejledning: [],
        vejledningIsLoading: true,
        gamleForloebUdenGodkendelse: [],
        gamleForloebUdenGodkendelseIsLoading: true
    });

    const setDashboardListData = useCallback((payload: DashboardListForloebModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetDashboardListData,
            payload: {dashboardListData: payload}
        });
    }, []);

    const setDashboardListUkoData = useCallback((payload: DashboardListUkoModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetDashboardListUkoData,
            payload: {dashboardListUkoData: payload}
        });
    }, []);

    const setDashboardListDataIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetDashboardListDataIsLoading,
            payload: {dashboardListDataIsLoading: payload}
        });
    }, []);

    const setUddannelseslaeger = useCallback((payload: DashboardForloebModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetUddannelseslaeger,
            payload: {uddannelseslaeger: payload}
        });
    }, []);

    const setUddannelseslaegerIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetUddannelseslaegerIsLoading,
            payload: {uddannelseslaegerIsLoading: payload}
        });
    }, []);

    const setVejledersamtaler = useCallback((payload: DashboardVejledersamtaleModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetVejledersamtaler,
            payload: {vejledersamtaler: payload}
        });
    }, []);

    const setVejledersamtalerIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetVejledersamtalerIsLoading,
            payload: {vejledersamtalerIsLoading: payload}
        });
    }, []);

  const setUddannelsesplaner = useCallback((payload: DashboardUddannelsesplanModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetUddannelsesplaner,
            payload: {uddannelsesplaner: payload}
        });
    }, []);

    const setUddannelsesplanerIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetUddannelsesplanerIsLoading,
            payload: {uddannelsesplanerIsLoading: payload}
        });
    }, []);

    const setKompetenceProgress = useCallback((payload: DashboardBrugerKompetenceProgressModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetKompetenceProgress,
            payload: {kompetenceProgress: payload}
        });
    }, []);

    const setKompetenceProgressIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetKompetenceProgressIsLoading,
            payload: {kompetenceProgressIsLoading: payload}
        });
    }, []);

    const setKompetenceAktivitet = useCallback((payload: DashboardBrugerKompetenceAktivitetModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetKompetenceAktivitet,
            payload: {kompetenceAktivitet: payload}
        });
    }, []);

    const setKompetenceAktivitetIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetKompetenceAktivitetIsLoading,
            payload: {kompetenceAktivitetIsLoading: payload}
        });
    }, []);

    const setKompetenceKlarmeldinger = useCallback((payload: DashboardKompetenceKlarmeldtModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetKompetenceKlarmeldinger,
            payload: {kompetenceKlarmeldinger: payload}
        });
    }, []);

    const setKompetenceKlarmeldingerIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetKompetenceKlarmeldingerIsLoading,
            payload: {kompetenceKlarmeldingerIsLoading: payload}
        });
    }, []);

    const setVejledning = useCallback((payload: DashboardVejledningModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetVejledning,
            payload: {vejledning: payload}
        });
    }, []);

    const setVejledningIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetVejledningIsLoading,
            payload: {vejledningIsLoading: payload}
        });
    }, []);

    const setGamleForloebUdenGodkendelse = useCallback((payload: DashboardForloebManglerGodkendelseModel[]) => {
        dispatch({
            type: DashboardReducerActionType.SetGamleForloebUdenGodkendelse,
            payload: {gamleForloebUdenGodkendelse: payload}
        });
    }, []);

    const setGamleForloebUdenGodkendelseIsLoading = useCallback((payload: boolean) => {
        dispatch({
            type: DashboardReducerActionType.SetGamleForloebUdenGodkendelseIsLoading,
            payload: {gamleForloebUdenGodkendelseIsLoading: payload}
        });
    }, []);


    return (
        <DashboardContext.Provider
            value={{
                state,
                setDashboardListData,
                setDashboardListUkoData,
                setDashboardListDataIsLoading,
                setUddannelseslaeger,
                setUddannelseslaegerIsLoading,
                setVejledersamtaler,
                setVejledersamtalerIsLoading,
                setUddannelsesplaner,
                setUddannelsesplanerIsLoading,
                setKompetenceProgress: setKompetenceProgress,
                setKompetenceProgressIsLoading: setKompetenceProgressIsLoading,
                setKompetenceAktivitet: setKompetenceAktivitet,
                setKompetenceAktivitetIsLoading: setKompetenceAktivitetIsLoading,
                setKompetenceKlarmeldinger: setKompetenceKlarmeldinger,
                setKompetenceKlarmeldingerIsLoading: setKompetenceKlarmeldingerIsLoading,
                setVejledning: setVejledning,
                setVejledningIsLoading: setVejledningIsLoading,
                setGamleForloebUdenGodkendelse: setGamleForloebUdenGodkendelse,
                setGamleForloebUdenGodkendelseIsLoading: setGamleForloebUdenGodkendelseIsLoading
            }}
        >
            {children}
        </DashboardContext.Provider>
    );
};

export default DashboardContextProvider;
